<template>
  <div>
    <v-container class="grey lighten-5" fluid>
      <v-row v-if="userDetails && Object.entries(userDetails).length">
        <v-col cols="12">
          <v-card>
            <v-card-title>Dane użytkownika</v-card-title>
            <v-card-text>
              <v-form ref="userDetailsForm">
                <v-row>
                  <v-col cols="12" sm="5" md="3" lg="2">
                    <v-text-field
                        v-model="userDetails.username"
                        class="pt-0"
                        label="Login"
                        placeholder=" "
                        :counter="40"
                        disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="7" md="2" lg="2">
                    <v-text-field
                        v-model="userDetails.email"
                        class="pt-0"
                        label="Email"
                        placeholder=" "
                        :counter="254"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="5" md="2" lg="2">
                    <v-text-field
                        v-model="userDetails.name"
                        class="pt-0"
                        label="Imię"
                        placeholder=" "
                        :counter="100"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="7" md="2" lg="2">
                    <v-text-field
                        v-model="userDetails.surname"
                        class="pt-0"
                        label="Nazwisko"
                        placeholder=" "
                        :counter="100"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="7" md="2" lg="2">
                    <v-text-field
                        v-model="userDetails.info"
                        class="pt-0"
                        label="Dodatkowe informacje"
                        placeholder=" "
                        :counter="100"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="5" lg="2">
                    <v-text-field
                        v-model="userDetails.phone"
                        class="pt-0"
                        label="Telefon"
                        placeholder=" "
                        :counter="30"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="7" lg="4">
                    <v-text-field
                        v-model="userDetails.activationToken"
                        class="pt-0"
                        label="Token aktywacyjny"
                        placeholder=" "
                        :counter="64"
                        disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="5" lg="4">
                    <v-text-field
                        v-model="userDetails.createdAt"
                        class="pt-0"
                        label="Zarejestrowano"
                        placeholder=" "
                        disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3" md="2" lg="2">
                    <div class="pb-0 disabled-label">
                      Potwierdzony:
                    </div>
                    <v-switch
                        v-model="userDetails.isConfirmed"
                        class="mt-0 pt-0"
                        :label="userDetails.isConfirmed ? 'Tak' : 'Nie'"
                        readonly
                        disabled
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" lg="2">
                    <div class="pb-0 disabled-label">
                      Zaakceptował warunki:
                    </div>
                    <v-switch
                        v-model="userDetails.termsOfService"
                        class="mt-0 pt-0"
                        :label="userDetails.termsOfService ? 'Tak' : 'Nie'"
                        readonly
                        disabled
                    ></v-switch>
                  </v-col>
                  <v-col cols="12">
                    <v-color-picker v-model="userDetails.color" hide-inputs></v-color-picker>
                  </v-col>
                  <v-col cols="12" sm="4" md="2" lg="2">
                    <div class="pb-0 disabled-label mb-2">
                      Partner:
                    </div>
                    <v-btn
                        v-if="userDetails.partnerId"
                    >
                      <router-link
                          :to="{name: 'user-details', params: { id: userDetails.partnerId }}"
                      >
                        Konto
                      </router-link>
                    </v-btn>
                    &nbsp;
                    <v-btn
                        v-if="userDetails.partnerCompanyId"
                    >
                      <router-link
                          :to="{name: 'company-details', params: { id: userDetails.partnerCompanyId }}"
                      >
                        Firma
                      </router-link>
                    </v-btn>
                    <span
                        v-if="!userDetails.partnerId && !userDetails.partnerCompanyId"
                    >
                      Brak
                    </span>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn
                  @click="saveUserDetails"
              >
                Zapisz
                <v-icon size="24" right>
                  mdi-content-save-outline
                </v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card-text class="text-center">
            <v-btn
                v-if="userDetails.companyId"
                class="mx-3"
                @click="goToCompanyDetails(userDetails.companyId)"
            >
              Przejdź do firmy
            </v-btn>
          </v-card-text>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title>
              Notatki
            </v-card-title>
            <v-card-text>
              <Notes
                  :id="this.id"
                  url-add="/api/users/{parentId}/notes"
                  url-delete="/api/users/{parentId}/notes/{id}"
                  url-update="/api/users/{parentId}/notes/{id}"
                  url-list="/api/users/{parentId}/notes"
              ></Notes>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title>Abonament</v-card-title>
            <v-card-text>
              <v-form ref="userSubscriptionForm">
                <v-row>
                  <v-col>
                    <v-select
                        v-model="subscription.planId"
                        :items="plans"
                        :disabled="!plansLoaded"
                        item-text="text"
                        item-value="value"
                        label="Plan"
                    />
                  </v-col>
                  <v-col>
                    <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="30"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="subscriptionStart"
                            label="Początek subskrypcji"
                            prepend-icon="mdi-calendar-blank"
                            readonly
                            clearable
                            v-bind="attrs"
                            v-on="on"
                            hide-details
                        />
                      </template>
                      <v-date-picker
                          v-model="subscriptionStart"
                          show-adjacent-months
                          show-current
                          :first-day-of-week="1"
                          @change="onSubscriptionStartChanged"
                      />
                    </v-menu>
                  </v-col>
                  <v-col>
                    <v-text-field
                        v-model="subscriptionLength"
                        type="number"
                        aria-valuemin="1"
                        label="Długość w miesiącach"
                    />
                  </v-col>
                </v-row>
                <v-row v-if="changingSubscription">
                  <v-col>
                    <v-alert
                        dense
                        outlined
                        type="warning"
                    >
                      Uwaga - po kliknięciu "Zapisz" nastąpi anulowanie wszystkich istniejących subskrypcji tego
                      użytkownika, a następnie utworzenie nowej na podany okres.
                      Podany okres zostanie również zaokrąglony do pełnych miesięcy, nie mniej niż 1 miesiąc.
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center">
                    <v-btn
                        class="mx-3"
                        @click="goToSubscriptionList(userId)"
                    >
                      Przejdź do listy subskrypcji
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn
                  @click="saveUserSubscription"
                  :disabled="!plansLoaded"
              >
                Zapisz
                <v-icon size="24" right>
                  mdi-content-save-outline
                </v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title>
              Punkty
            </v-card-title>
            <v-card-text>
              <div class="pb-3">
                Suma zdobytych punktów: <strong>{{ scoring.score }}</strong>
              </div>
              <v-expansion-panels
                  v-if="scoring.rewards && scoring.rewards.length"
                  style="flex:0;min-width:180px"
                  class="text-center"
              >
                <v-expansion-panel>
                  <v-expansion-panel-header
                      color="blue-grey lighten-4"
                  >
                    Nagrody
                  </v-expansion-panel-header>
                  <v-expansion-panel-content
                      color="blue-grey lighten-4"
                  >
                    <v-simple-table class="text-left">
                      <thead>
                      <tr>
                        <th style="width:1%">
                          Ikona
                        </th>
                        <th style="width:1%">
                          Punkty
                        </th>
                        <th>
                          Tytuł / opis
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(reward, i) in scoring.rewards"
                          :key="i"
                      >
                        <td>
                          <v-icon v-if="reward.icon">
                            {{ reward.icon }}
                          </v-icon>
                        </td>
                        <td>
                          {{ reward.score }}
                        </td>
                        <td>
                          <v-expansion-panels flat tile>
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                                {{ reward.title }}
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                {{ reward.description }}
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </td>
                      </tr>
                      </tbody>
                    </v-simple-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title>
              Uprawnienia (role)
            </v-card-title>
            <v-card-text class="text-center">
              <v-checkbox
                  v-if="userRoles.ROLE_DEVELOPER"
                  v-model="userRoles.ROLE_DEVELOPER"
                  label="Deweloper"
                  hide-details
                  readonly
                  disabled
                  class="d-inline-block mx-3"
              />
              <v-checkbox
                  v-model="userRoles.ROLE_SUPER_ADMIN"
                  label="Super admin"
                  hide-details
                  readonly
                  disabled
                  class="d-inline-block mx-3"
              />
              <v-checkbox
                  v-model="userRoles.ROLE_ADMIN"
                  label="Admin"
                  hide-details
                  readonly
                  :disabled="userDetails.roles && userDetails.roles.includes('ROLE_ADMIN')"
                  class="d-inline-block mx-3"
              />
              <v-checkbox
                  v-model="userRoles.ROLE_SUPERVISOR"
                  label="Opiekun"
                  hide-details
                  class="d-inline-block mx-3"
              />
              <v-checkbox
                  v-model="userRoles.ROLE_TRADER"
                  label="Handlowiec"
                  hide-details
                  class="d-inline-block mx-3"
              />
              <v-checkbox
                  v-model="userRoles.ROLE_EDITOR"
                  label="Redaktor"
                  hide-details
                  class="d-inline-block mx-3"
              />
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                   <v-checkbox
                       v-model="userRoles.ROLE_PARTNER"
                       label="Partner"
                       hide-details
                       :disabled="!isAdmin"
                       class="d-inline-block mx-3"
                   />
                  </span>
                </template>
                <span>
                  Konto z tą rolą umożliwia tworzenie nowych kont (dla klientów) bezpośrednio z poziomu aplikacji
                  i zarządzanie nimi (w ograniczonym stopniu).
                  Partner może również dodawać oferty w imieniu swoich klientów.
                </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                   <v-checkbox
                       v-model="userRoles.ROLE_REGISTERED"
                       label="Zarejestrowany"
                       hide-details
                       readonly
                       disabled
                       class="d-inline-block mx-3"
                   />
                  </span>
                </template>
                <span>
                  Ta rola nie reprezentuje typowo uprawnień. Określa, że dane konto jest kontem w pełni zarejestrowanym.
                  Konto w pełni zarejestrowane to takie konto, które zostało utworzone wprost z formularza rejestracji
                  LUB zostało przekształcone z konta gościa.
                </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                   <v-checkbox
                       v-model="userRoles.ROLE_GUEST"
                       label="Gość"
                       hide-details
                       readonly
                       disabled
                       class="d-inline-block mx-3"
                   />
                  </span>
                </template>
                <span>
                  Ta rola nie reprezentuje typowo uprawnień. Określa, że dane konto zostało automatycznie utworzone
                  przez system podczas wizyty niezalogowanego i nierozpoznanego użytkownika. Takie konto może stać
                  się kontem w pełni zarejestrowanym, jeśli gość przejdzie proces rejestracji.
                </span>
              </v-tooltip>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn
                  @click="saveUserRoles"
              >
                Zapisz
                <v-icon size="24" right>
                  mdi-content-save-outline
                </v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title>
              Tokeny Firebase
            </v-card-title>
            <v-card-text>
              <div
                  v-if="userDetails.fbIds && userDetails.fbIds.length"
                  class="text-center"
              >
                <v-chip
                    v-for="(tokenFragment, i) in userDetails.fbIds"
                    :key="i"
                    class="ma-2"
                    label
                >
                  {{ tokenFragment }}
                </v-chip>
              </div>
              <span v-if="!userDetails.fbIds || !userDetails.fbIds.length">
                Brak.
              </span>
              <v-alert
                  v-if="userDetails.fbIds && userDetails.fbIds.length"
                  class="mx-auto mt-3"
                  style="max-width:520px"
                  dense
                  border="top"
                  colored-border
                  type="info"
                  elevation="2"
              >
                Dla bezpieczeństwa wyświetlane jest do 10 ostatnich znaków.
              </v-alert>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title>
              Tokeny Mercure
            </v-card-title>
            <v-card-text>
              <v-container fluid class="pa-0">
                <v-row>
                  <v-col>
                    <v-text-field
                        v-model="userDetails.mercureTopic"
                        class="pt-0"
                        label="Topic Mercure"
                        placeholder=" "
                        disabled
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                        v-model="userDetails.mercureToken"
                        class="pt-0"
                        label="Topic Mercure"
                        placeholder=" "
                        disabled
                    />
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" class="pa-0">
                    <v-alert
                        class="mx-auto mt-2"
                        style="max-width:520px"
                        dense
                        border="top"
                        colored-border
                        type="info"
                        elevation="2"
                    >
                      Dla bezpieczeństwa wyświetlane jest do 10 ostatnich znaków.
                    </v-alert>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title>
              Kampanie reklamowe
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="userDetails.campaignId"
                readonly
                placeholder="ID kampanii"
                hint="ID kampanii z której pozyskano tego użytkownika."
                persistent-hint
                :counter="255"
                aria-valuemax="255"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        v-if="isAdmin() || isTrader()"
      >
        <v-col cols="12">
          <v-card>
            <v-card-title>
              Wyślij SMS do użytkownika
            </v-card-title>
            <v-card-text>
              <SendSms
                :user-id="userId"
              ></SendSms>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row
          v-if="isAdmin() || isTrader()"
      >
        <v-col cols="12">
          <v-card>
            <v-card-title>
              Wyślij powiadomienia do użytkownika
            </v-card-title>
            <v-card-text>
              <AddNotification
                  :target-users="[userId]"
                  :fb-ids-available="userDetails.fbIds && userDetails.fbIds.length"
              ></AddNotification>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row
          v-if="isAdmin() || isTrader()"
      >
        <v-col cols="12">
          <v-card>
            <v-card-title>
              Historia wysyłanych wiadomości
            </v-card-title>
            <v-card-text>
              <data-table
                  :headers="messagesTableHeaders"
                  :items="userDetails.messages"
                  :server-items-length="userDetails.messages.length"
                  :loading="loading"
                  class="row-pointer"
              >
                <template v-slot:item.body="{ item }">
                  {{ item.type == 'email' ? item.subject : item.body }}
                  <v-dialog
                      v-model="dialog"
                      width="720px"
                      scrollable
                  >
                    <template v-if="item.type == 'email'" v-slot:activator="{ on, attrs }">
                      <v-btn
                          class="mx-2"
                          v-bind="attrs"
                          v-on="on"
                      >
                        Treść
                      </v-btn>
                    </template>

                    <v-card>
                      <v-card-text v-html="item.body"></v-card-text>
                    </v-card>
                  </v-dialog>
                </template>
                <template v-slot:item.createdAt="{ item }">
                  {{ localDateTime(item.createdAt) }}
                </template>
                <template v-slot:item.id="{ item }">
                  <v-btn
                      class="mx-2"
                      @click="sendMessage(item.id)"
                  >
                    Wyślij ponownie
                  </v-btn>
                </template>
              </data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <modal-loader :show="loading" />
  </div>
</template>

<script>
import api from '../services/api';
import humanFileSize from '../mixins/humanFileSize';
import ModalLoader from '@/components/ModalLoader';
import formatters from "@/mixins/formatters";
import permissions from "@/mixins/permissions";
import {getItems as getUserConfirmedItems} from '@/enums/UserConfirmed';
import SendSms from '@/components/SendSms';
import AddNotification from "@/components/notifications/AddNotification";
import moment from 'moment';
import DataTable from '@/components/data-table/DataTable';
import Notes from "@/components/notes/Notes.vue";

export default {
  components: {
    Notes,
    AddNotification,
    ModalLoader,
    SendSms,
    DataTable,
  },
  mixins: [
    formatters,
    humanFileSize,
    permissions,
  ],
  props: ['id'],
  savedUserDetails: null,
  data() {
    const today = moment().format('YYYY-MM-DD');

    return {
      loading: false,
      loadingDetails: false,
      loadingPlans: false,
      loadingSubscriptionDetails: false,
      loadingScoring: false,

      userId: null,
      confirmedStatuses: getUserConfirmedItems(),
      rules: {},
      rawUserDetails: [],

      menu1: false,
      minSubscriptionDate: today,
      subscriptionStart: today,
      subscriptionLength: 1,

      scoring: {
        score: 0,
        rewards: [],
      },

      rawPlans: [],
      plansLoaded: false,

      rawSubscriptionDetails: {
        planId: null,
      },
      subscription: {
        planId: null,
      },

      packs: [],
      photos: [],
      codeBeingSend: false,

      messagesTableHeaders: [
        {text: 'Wiadomość', value: 'body', sortable: false, width: "80%"},
        {text: 'Typ', value: 'type', sortable: false},
        {text: 'Data', value: 'createdAt', sortable: false},
        {text: 'Wyślij', value: 'id', sortable: false},
      ],
    }
  },
  computed: {
    userDetails() {
      // Warning: From API's point of view selectedIds that evaluates to false means "do not update this field".

      return {
        partnerId: this.rawUserDetails.partnerId || null,
        partnerCompanyId: this.rawUserDetails.partnerCompanyId || null,
        companyId: this.rawUserDetails.companyId || null,
        username: this.rawUserDetails.username || null,
        email: this.rawUserDetails.email || null,
        name: this.rawUserDetails.name || null,
        surname: this.rawUserDetails.surname || null,
        phone: this.rawUserDetails.phone || null,
        roles: this.rawUserDetails.roles || null,
        activationToken: this.rawUserDetails.activationToken || null,
        confirmed: this.rawUserDetails.confirmed || null,
        termsOfService: this.rawUserDetails.termsOfService || null,
        isConfirmed: '1' === this.rawUserDetails.confirmed,
        fbIds: this.rawUserDetails.fbIds || [],
        mercureTopic: this.rawUserDetails.mercureTopic || null,
        mercureToken: this.rawUserDetails.mercureToken || null,
        subscriptionId: this.rawUserDetails.subscriptionId || null,
        campaignId: String(this.rawUserDetails.campaignId || ''),
        createdAt: this.localDateTime(this.rawUserDetails.createdAtDto),
        messages: this.rawUserDetails.messages || [],
        color: this.rawUserDetails.color || '',
        code: this.rawUserDetails.code || null,
        info: this.rawUserDetails.info || '',
      };
    },
    userRoles() {
      const roles = this.rawUserDetails.roles || [];

      return {
        ROLE_DEVELOPER: roles.includes('ROLE_DEVELOPER'),
        ROLE_SUPER_ADMIN: roles.includes('ROLE_SUPER_ADMIN'),
        ROLE_ADMIN: roles.includes('ROLE_ADMIN'),
        ROLE_TRADER: roles.includes('ROLE_TRADER'),
        ROLE_SUPERVISOR: roles.includes('ROLE_SUPERVISOR'),
        ROLE_EDITOR: roles.includes('ROLE_EDITOR'),
        ROLE_CALL_CENTER: roles.includes('ROLE_CALL_CENTER'),
        ROLE_PARTNER: roles.includes('ROLE_PARTNER'),
        ROLE_REGISTERED: roles.includes('ROLE_REGISTERED'),
        ROLE_GUEST: roles.includes('ROLE_GUEST'),
      };
    },
    plans() {
      let plans = [], price1, price2, title;

      for (const plan of this.rawPlans) {
        price1 = this.formatAmount(plan.priceInPln);
        price2 = this.formatAmount(plan.yearlyPriceInPln);
        title = `${plan.name} (${price1} zł / msc; ${price2} zł / rok)`;

        plans.push(
            {
              value: plan.id,
              text: title,
            }
        );
      }

      return plans;
    },
    changingSubscription() {
      const s = this.subscription;

      if (s.planId !== this.rawSubscriptionDetails.planId) {
        return true;
      }

      const pF = s.periodFrom;
      const pT = s.periodTo;

      if (pF && pT) {
        const d1 = pF.formatted.substr(0, 10);
        const d2 = pT.formatted.substr(0, 10);

        return !this.areDateRangesEqual(
            [d1, d2],
            [
                this.subscriptionStart,
                moment(this.subscriptionStart).add(this.subscriptionLength, 'M').format('YYYY-MM-DD')
            ]
        );
      }

      return false;
    }
  },
  methods: {
    areDateRangesEqual(range1, range2) {
        return range1.join('_') === range2.join('_');
    },
    goToCompanyDetails(id) {
      this.$router.push({name: 'company-details', params: {id: id}})
          .catch((error) => {
            console.error('Error during redirection:', error);
          });
    },
    goToSubscriptionList(id) {
      this.$router.push({name: 'subscriptions', query: {userId: id}})
          .catch((error) => {
            console.error('Error during redirection:', error);
          });
    },
    async loadDetails() {
      if (this.loadingDetails) {
        return;
      }

      this.loadingDetails = true;

      let response;

      try {
        response = await api.get(`/api/users/${this.userId}?includeMessages=true`);
      } catch (error) {
        this.$root.$emit('notifyError', {
          html: 'Nie udało się wczytać danych użytkownika.',
          error,
        });

        return;
      }

      this.loadingDetails = false;

      this.rawUserDetails = response.data;
      this.savedUserDetails = JSON.parse(JSON.stringify(this.userDetails));

      if (this.userDetails.subscriptionId) {
        this.loadSubscriptionDetails();
      }
    },
    async saveUserDetails() {
      if (!this.$refs.userDetailsForm.validate()) {
        return;
      }

      this.userDetails.color = this.userDetails.color ? this.userDetails.color.hex : '';

      // The following variable will contain only those fields that were modified.
      const dataToSave = this.getObjectDiff(this.userDetails, this.savedUserDetails);

      if (!Object.keys(dataToSave).length) {
        this.$root.$emit('notify', {
          html: 'Nie ma nic nowego do zapisania.'
        });

        return;
      }

      this.loading = true;
      let response;

      try {
        response = await api.put(`/api/users/${this.userId}`, dataToSave);
      } catch (error) {
        /** @see https://github.com/axios/axios#handling-errors */
        this.loading = false;
        this.$root.$emit('notifyError', {
          html: 'Nie udało się zapisać danych użytkownika.',
          error
        });

        return;
      }

      this.rawUserDetails = response.data;
      this.savedUserDetails = JSON.parse(JSON.stringify(this.userDetails));
      this.loading = false;
      this.$root.$emit('notifySuccess', {
        html: 'Dane użytkownika zostały zapisane.'
      });
    },
    loadPlans() {
      if (this.loadingPlans) {
        return;
      }

      this.loadingPlans = true;

      api.get(`/api/subscription/plan`)
          .then((response) => {
            const data = response.data;

            this.rawPlans = data.items;
            this.plansLoaded = true;
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się wczytać listy planów abonamentowych.',
              error,
            });
          })
          .finally(() => {
            this.loadingPlans = false;
          });
    },
    loadSubscriptionDetails() {
      if (this.loadingSubscriptionDetails) {
        return;
      }

      this.loadingSubscriptionDetails = true;

      api.get(`/api/subscription/${this.userDetails.subscriptionId}`)
          .then((response) => {
            const data = response.data;
            const periodFrom = data.periodFrom.formatted.substr(0, 10);
            const periodTo = data.periodTo.formatted.substr(0, 10);

            this.rawSubscriptionDetails = JSON.parse(JSON.stringify(data));
            this.subscription = data;
            this.subscriptionStart = periodFrom;
            this.subscriptionLength = Math.max(1, moment(periodTo).diff(moment(periodFrom), 'months'));
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się wczytać danych subskrypcji.',
              error,
            });
          })
          .finally(() => {
            this.loadingSubscriptionDetails = false;
          });
    },
    saveUserSubscription() {
      if (!this.$refs.userSubscriptionForm.validate()) {
        return;
      }

      if (!this.changingSubscription) {
        this.$root.$emit('notify', {
          html: 'Nie ma nic nowego do zapisania.'
        });

        return;
      }

      api
        .post(`/api/subscription/change`, {
          userId: this.userId,
          planId: this.subscription.planId,
          periodFrom: this.subscriptionStart,
          months: this.subscriptionLength,
        })
        .then((response) => {
          const data = response.data;
          const periodFrom = data.periodFrom.formatted.substr(0, 10);
          const periodTo = data.periodTo.formatted.substr(0, 10);

          this.rawSubscriptionDetails = JSON.parse(JSON.stringify(data));
          this.subscription = data;
          this.subscriptionStart = periodFrom;
          this.subscriptionLength = Math.max(1, moment(periodTo).diff(moment(periodFrom), 'months'));

          this.$root.$emit('notifySuccess', {
            html: 'Subskrypcja została ustawiona.'
          });
        })
        .catch((error) => {
          this.$root.$emit('notifyError', {
            html: 'Nie udało się ustawić nowej subskrypcji.',
            error,
          });
        })
    },
    loadScoring() {
      if (this.loadingScoring) {
        return;
      }

      this.loadingScoring = true;

      api.get(`/api/scoring/user/${this.userId}`)
          .then((response) => {
            const data = response.data;

            this.scoring.score = data.score || 0;
            this.scoring.rewards = data.rewards || [];
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się wczytać informacji dotyczących punktów zdobytych przez użytkownika.',
              error,
            });
          })
          .finally(() => {
            this.loadingScoring = false;
          });
    },
    async saveUserRoles() {
      this.loading = true;
      const dataToSave = {
        roles: this.userRoles,
      }
      let response;

      try {
        response = await api.put(`/api/account/roles/${this.userId}/update`, dataToSave);
      } catch (error) {
        /** @see https://github.com/axios/axios#handling-errors */
        this.loading = false;
        this.$root.$emit('notifyError', {
          html: 'Nie udało się zapisać uprawnień (ról).',
          error
        });

        return;
      }

      this.rawUserDetails.roles = response.data.roles;
      this.savedUserDetails = JSON.parse(JSON.stringify(this.userDetails));
      this.loading = false;
      this.$root.$emit('notifySuccess', {
        html: 'Uprawnienia (role) użytkownika zostały zapisane.'
      });
    },
    getObjectDiff(obj1, obj2) {
      const diffObject = {};

      for (const key of Object.keys(obj1)) {
        if (obj1[key] instanceof Object) {
          const nestedObj = this.getObjectDiff(obj1[key], obj2[key]);

          if (Object.keys(nestedObj).length > 0) {
            diffObject[key] = nestedObj;
          }
        } else if (obj1[key] !== obj2[key]) {
          diffObject[key] = obj1[key];
        }
      }

      return diffObject;
    },
    onSubscriptionStartChanged(/*date*/) {
      this.menu1 = false;
    },
    sendMessage(id) {
      api
          .post('/api/users/sendMessage/' + id, {})
          .then(() => {
            this.$root.$emit('notifySuccess', {
              html: 'Wiadomość została wysłana.',
            });
            this.loadDetails();
          })
          .catch((error) => {
            console.error('Error when adding a dimension:', error);
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
          })
    }
  },
  async created() {
    try {
      this.userId = this.id; // Store new user id in the local variable.
      await this.loadDetails();
    } catch (e) {
      void (0);
    }

    this.loadPlans();
    this.loadScoring();
  },
  beforeRouteUpdate(to, from, next) {
    next(); // Update the URL in address bar.
    this.userId = to.params.id; // Store new user id in the local variable.
    this.loadDetails();
    this.loadPlans();
    this.loadScoring();
  },
}
</script>

<style scoped>
.v-data-table
/deep/
tbody
/deep/
tr:hover:not(.v-data-table__expanded__content) {
  background: #ffffff !important;
}

/* For Simple Tables. */
tbody > tr:hover {
  background-color: transparent !important;
}
</style>
<style>
.disabled-label {
  margin-top: -10px;
  height: 20px;
  line-height: 20px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.38);
}
</style>
